//import { languages } from "prismjs";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { useAuth } from "../../../../app/modules/auth";
import { AppState, GETCURRENCYCODE, GETWALLETBALANCE } from "../../../../redux/types";
import { getAccountCurrency, getWalletBalance } from "../../../../app/modules/auth/core/_requests";
function HeaderBalanceMenu() {
	const { logout } = useAuth();
	const dispatch = useDispatch();
	//const navigate = useNavigate();
	const [currencyList, setCurrencyList] = useState([]);
	/* get data from redux */
	//const language = useSelector((state: AppState) => state.language);
	let token = useSelector((state: AppState) => state.token);
	let currency = useSelector((state: AppState) => state.currencyCode);
	let balance = useSelector((state: AppState) => state.walletBalance);
	/* get data from redux */

	const fetchCurrencyData = async () => {
		try {
			const responce = await getAccountCurrency(token);
			const message = responce?.data?.message;

			if (responce.status === 200) {
				let filterCurrency = responce?.data?.data?.map((item) => {
					return item?.currency_code;
				});

				setCurrencyList([...filterCurrency]);
			} else {
				Swal.fire({
					icon: "info",
					title: message,
					text: message,
				});
			}
		} catch (error: any) {
			let message = "";
			if (error?.response?.status === 403 || error?.response?.status === "403") {
				logout();
			}

			message = error.response?.data?.message;
			if (error.code === "ERR_NETWORK") {
				message = "Network Error";
			}
			Swal.fire({
				icon: "error",
				title: "Error",
				text: message,
			});
			setCurrencyList([]);
		}
	};

	const fetchWalletBalance = async () => {
		try {
			const responce = await getWalletBalance(token, currency);
			const message = responce?.data?.message;
			if (responce.status === 200) {
				let filterBalance = responce?.data?.data?.balance;
				dispatch({ type: GETWALLETBALANCE, payload: filterBalance });
			} else {
				Swal.fire({
					icon: "info",
					title: message,
					text: message,
				});
			}
		} catch (error: any) {
			let message = "";
			if (error?.response?.status === 403 || error?.response?.status === "403") {
				logout();
			}

			message = error.response?.data?.message;
			if (error.code === "ERR_NETWORK") {
				message = "Network Error";
			}
			Swal.fire({
				icon: "error",
				title: "Error",
				text: message,
			});
			dispatch({ type: GETWALLETBALANCE, payload: "" });
		}
	};

	const handelUpdateCurrency = (item) => {
		dispatch({ type: GETCURRENCYCODE, payload: item });
	};

	// eslint-disable-next-line react-hooks/exhaustive-deps
	useEffect(() => {
		fetchCurrencyData();
	}, []);

	useEffect(() => {
		fetchWalletBalance();
	}, [currency]);

	const number_format = (num) => {
    if (
      num === "--" ||
      num === null ||
      num === undefined ||
      isNaN(Number(num.toString().replace(/,/g, "")))
    ) {
      return "--";
    }

    return Number(num.toString().replace(/,/g, "")).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

	return (
		<div className='small-screen-text fs-5'>
			<span className='small-screen-text fw-semibold fs-7 text-uppercase' style={{marginRight:6}}><strong>CREDIT : </strong> 
			{number_format(balance)} &nbsp;
			{/* <span className="badge badge-secondary"> KRW</span> */}
			</span>
			
			<Link to='#' data-kt-menu-trigger='click' data-kt-menu-placement='bottom-end' data-kt-menu-flip='top-end' className="krw_sec">
				{currency}
				<span className='svg-icon fs-5 m-0'>
					<svg xmlns='http://www.w3.org/2000/svg' width='24px' height='24px' viewBox='0 0 24 24' version='1.1'>
						<g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
							<polygon points='0 0 24 0 24 24 0 24'></polygon>
							<path
								d='M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z'
								fill='currentColor'
								fillRule='nonzero'
								transform='translate(12.000003, 11.999999) rotate(-180.000000) translate(-12.000003, -11.999999)'></path>
						</g>
					</svg>
				</span>
			</Link>

			<div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-225px py-4' data-kt-menu='true'>
				{currencyList.length > 0 ? (
					currencyList.map((item, idx) => (
						<div className='menu-item px-2 ' key={idx}>
							<Link to={"#"} className='menu-link px-3' data-kt-docs-table-filter='edit_row' onClick={(e) => handelUpdateCurrency(item)}>
								{item}
							</Link>
						</div>
					))
				) : (
					<div className='menu-item px-2 '>
						<Link to={"#"} className='menu-link px-3' data-kt-docs-table-filter='edit_row'>
							No Currency Found
						</Link>
					</div>
				)}
			</div>
		</div>
	);
}

export { HeaderBalanceMenu };
